import { motion } from "framer-motion";
import { Palette } from "lucide-react";

const CULTURE_ITEMS = [
  { title: "Museums", img: "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=1600" },
  { title: "Auditoriums", img: "https://images.unsplash.com/photo-1614521084980-811d04f6c6cb?q=85&w=1600" },
  { title: "Convention Centres", img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=85&w=1600" },
  { title: "Art Galleries", img: "https://images.unsplash.com/photo-1577720580479-7d839d829c73?q=85&w=1600" },
  { title: "Heritage Conservation", img: "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=1600" },
  { title: "Cultural Centres", img: "https://images.unsplash.com/photo-1577083287902-c25e21c5f4d8?q=85&w=1600" },
  { title: "Public Spaces", img: "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=1600" },
  { title: "Creative Urban Design", img: "https://images.pexels.com/photos/11310491/pexels-photo-11310491.jpeg?w=1600" },
];

export default function ArtCulture() {
  return (
    <section className="relative bg-navy text-white py-24 sm:py-32 overflow-hidden" data-testid="art-culture-section">
      <div className="absolute inset-0 hero-grid-overlay opacity-15" />
      <div className="container-x relative">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <Palette className="text-gold" size={20} />
              <span className="overline text-gold">Art &amp; Culture</span>
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Designing the spaces<br />where <span className="italic font-light text-gold">culture lives</span>.
            </h2>
          </div>
          <p className="text-white/65 max-w-md leading-relaxed">
            From museums to public squares, our cultural practice fuses heritage sensitivity with contemporary design language — for spaces that honour the past and invite the future.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {CULTURE_ITEMS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
              className={`group relative overflow-hidden aspect-[3/4] ${i % 3 === 0 ? "md:row-span-2 md:aspect-[3/8]" : ""}`}
              data-testid={`culture-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <img src={c.img} alt={c.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent opacity-90" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                <div className="font-display font-semibold text-white text-base sm:text-lg leading-tight">
                  {c.title}
                </div>
                <div className="mt-2 h-px w-6 bg-gold group-hover:w-12 transition-all duration-500" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
